import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ConfigProvider } from 'antd';

import { THEMES, DEFAULT_THEME, THEME_STORAGE_KEY, buildAntdTheme } from './themes';

const ThemeContext = createContext({
    themeKey: DEFAULT_THEME,
    setThemeKey: () => {},
    themes: THEMES,
});

export function ThemeProvider({ children }) {
    const [themeKey, setThemeKeyState] = useState(() => {
        try {
            const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
            if (stored && THEMES[stored]) return stored;
        } catch (e) {}
        return DEFAULT_THEME;
    });

    const setThemeKey = (key) => {
        if (!THEMES[key]) return;
        setThemeKeyState(key);
        try {
            window.localStorage.setItem(THEME_STORAGE_KEY, key);
        } catch (e) {}
    };

    useEffect(() => {
        const t = THEMES[themeKey] || THEMES[DEFAULT_THEME];
        document.body.style.backgroundColor =
            t.components?.Layout?.bodyBg || t.token?.colorBgLayout || '';
    }, [themeKey]);

    const antdTheme = useMemo(() => buildAntdTheme(themeKey), [themeKey]);
    const value = useMemo(
        () => ({ themeKey, setThemeKey, themes: THEMES }),
        [themeKey],
    );

    return (
        <ThemeContext.Provider value={value}>
            <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
